import React from 'react';
import { Reveal } from '../Reveal';
import { SectionEyebrow } from '../SectionEyebrow';
import { CheckIcon, BookOpenIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { BookMockup } from '../BookMockup';
import { GlowBorder } from '../GlowBorder';
const items = ['Libro digital completo en formato PDF.', 'Acceso instantáneo después de la compra.', 'Diez capítulos de crecimiento personal y reflexión.', 'Un sistema integral para cuerpo, mente, emociones, intuición y propósito.', 'Lectura profunda para volver a consultar en diferentes etapas de tu vida.', 'Una guía en español escrita con sensibilidad, claridad y visión espiritual.'];
export const ValueStack: React.FC = () => <section className="relative bg-navy-deep py-28 lg:py-44 overflow-hidden" data-id="element-384">
    <div className="absolute inset-0" style={{
    background: 'radial-gradient(ellipse at center, rgba(212,175,122,0.14), transparent 65%)'
  }} data-id="element-385" />
    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[70%] h-[60%] opacity-50 blur-3xl pointer-events-none" style={{
    background: 'radial-gradient(ellipse, rgba(212,175,122,0.2), transparent 70%)'
  }} data-id="element-386" />

    <div className="relative max-w-4xl mx-auto px-6 lg:px-8" data-id="element-387">
      <div className="text-center mb-12" data-id="element-388">
        <Reveal data-id="element-389">
          <SectionEyebrow data-id="element-390">Tu inversión</SectionEyebrow>
        </Reveal>
        <Reveal delay={0.1} data-id="element-391">
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-ivory leading-[1.1]" style={{
          fontWeight: 300
        }} data-id="element-392">
            Lo que recibes{' '}
            <span className="italic gold-text" style={{
            fontWeight: 400
          }} data-id="element-393">
              al obtener el libro
            </span>
          </h2>
        </Reveal>
      </div>

      {/* Book mockup above card */}
      <Reveal delay={0.12} data-id="element-394">
        <div className="flex justify-center mb-[-60px] sm:mb-[-80px] relative z-10" data-id="element-395">
          <BookMockup size="md" data-id="element-396" />
        </div>
      </Reveal>

      <Reveal delay={0.2} data-id="element-397">
        <GlowBorder intensity="bright" duration={8} borderRadius="rounded-3xl" data-id="element-398">
          <div className="bg-gradient-to-br from-navy-mid to-navy-deep rounded-3xl p-7 sm:p-8 lg:p-12 overflow-hidden relative" data-id="element-399">
            {/* Top glow */}
            <div className="absolute -top-32 -right-32 w-80 h-80 rounded-full opacity-25 blur-3xl" style={{
            background: 'radial-gradient(circle, rgba(212,175,122,0.7), transparent 70%)'
          }} data-id="element-400" />

            {/* Spacer for overlapping book */}
            <div className="h-16 sm:h-20" data-id="element-401" />

            <div className="relative grid lg:grid-cols-[1.2fr_1fr] gap-10 lg:gap-12 items-start" data-id="element-402">
              {/* Left: checklist */}
              <div data-id="element-403">
                <div className="flex flex-wrap items-center gap-3 mb-7" data-id="element-404">
                  <div className="flex items-center gap-2.5" data-id="element-405">
                    <BookOpenIcon className="w-5 h-5 text-gold" strokeWidth={1.5} data-id="element-406" />
                    <span className="font-serif italic text-gold text-base sm:text-lg" data-id="element-407">
                      Edición digital · 2025
                    </span>
                  </div>
                  <span className="text-[9px] uppercase tracking-eyebrow font-medium text-gold border border-gold/40 rounded-full px-3 py-1 bg-navy-deep/60 backdrop-blur-sm" data-id="element-408">
                    Acceso inmediato
                  </span>
                </div>
                <ul className="space-y-4" data-id="element-409">
                  {items.map(item => <li key={item} className="flex items-start gap-3 text-ivory/85 font-light leading-relaxed" data-id="element-410">
                      <CheckIcon className="w-5 h-5 text-gold flex-shrink-0 mt-0.5" strokeWidth={2} data-id="element-411" />
                      <span data-id="element-412">{item}</span>
                    </li>)}
                </ul>
              </div>

              {/* Right: price + CTA */}
              <div className="lg:border-l lg:border-gold/20 lg:pl-10 text-center" data-id="element-413">
                <p className="text-[10px] uppercase tracking-eyebrow text-ivory/40 mb-3" data-id="element-414">
                  Precio
                </p>
                <p className="font-serif gold-text mb-2 leading-none whitespace-nowrap" style={{
                fontWeight: 400,
                fontSize: 'clamp(48px, 12vw, 72px)'
              }} data-id="element-415">
                  $19{' '}
                  <span className="text-2xl lg:text-3xl text-gold/70 align-middle" data-id="element-416">
                    USD
                  </span>
                </p>
                <p className="text-sm text-ivory/50 mb-8 font-light italic" data-id="element-417">
                  Pago único · acceso permanente
                </p>
                <CTAButton size="lg" pulse fullWidth data-id="element-418">
                  Obtener el libro ahora
                </CTAButton>
              </div>
            </div>
          </div>
        </GlowBorder>
      </Reveal>
    </div>
  </section>;